import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerPyPI from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerPyPI';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle';
import ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT from '~/artifact/components/ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT';
type LibraryViewVersionEvidenceProps = {
  libraryState: object;
};
const LibraryViewVersionEvidence: React.SFC<LibraryViewVersionEvidenceProps> = props => {
  const { libraryState } = props;
  const { component = {}, version = '' } = libraryState;
  const { libraryModel = {} } = component;
  const { languageType = '', coordinateType = '', versions = [] } = libraryModel;
  const activeVersion =
    _.find(versions, release => {
      return release.version === version;
    }) || {};
  let { sha1 = '', sha2 = '', bytecodeHash = '' } = activeVersion;
  const language = languageType.toLowerCase();
  const packageManager = coordinateType.toLowerCase();
  let bytecodeHashElement;
  const packageManagerElements = [];
  const fileHashesElement = (
    <div className="grid">
      <div className="grid__item col-1-1 pt-">
        <div className="grid">
          <div className="grid__item col-1-8 text--bold phone--col-1-1">sha1:</div>
          <div className="grid__item col-7-8 phone--col-1-1 phone--no-overflow">{sha1}</div>
        </div>
      </div>
      <div className="grid__item col-1-1 pt-">
        <div className="grid">
          <div className="grid__item col-1-8 text--bold phone--col-1-1">sha2:</div>
          <div className="grid__item col-7-8  phone--col-1-1 phone--no-overflow">{sha2}</div>
        </div>
      </div>
    </div>
  );
  if (bytecodeHash) {
    bytecodeHashElement = (
      <div className="grid pt-">
        <div className="grid__item col-1-8 text--bold phone--col-1-1">bytecode:</div>
        <div className="grid__item col-7-8  phone--col-1-1 phone--no-overflow">{bytecodeHash}</div>
      </div>
    );
  }
  if (language === 'ruby') {
    packageManagerElements.push(
      <div key="gem" className="grid pb- phone--pl phone--pt">
        <div className="grid__item col-1-1">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerRubyGems
            component={libraryModel}
            version={activeVersion}
          />
        </div>
      </div>
    );
  } else if (language === 'python') {
    packageManagerElements.push(
      <div key="pypi" className="grid pb- phone--pl phone--pt">
        <div className="grid__item col-1-1">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerPyPI
            component={libraryModel}
            version={activeVersion}
          />
        </div>
      </div>
    );
  } else if (language === 'js') {
    if (packageManager === 'npm') {
      packageManagerElements.push(
        <div key="npm" className="grid pb- phone--pl phone--pt">
          <div className="grid__item col-1-1">
            <ArtifactViewMainContentSignaturesComponentVersionPackageManagerNPM
              component={libraryModel}
              version={activeVersion}
            />
          </div>
        </div>
      );
      packageManagerElements.push(
        <div key="yarn" className="grid pb- phone--pl phone--pt">
          <div className="grid__item col-1-1">
            <ArtifactViewMainContentSignaturesComponentVersionPackageManagerYarn
              component={libraryModel}
              version={activeVersion}
            />
          </div>
        </div>
      );
    } else if (packageManager === 'bower') {
      packageManagerElements.push(
        <div key="npm" className="grid pb- phone--pl phone--pt">
          <div className="grid__item col-1-1">
            <ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower
              component={libraryModel}
              version={activeVersion}
            />
          </div>
        </div>
      );
    }
  } else if (language === 'java') {
    packageManagerElements.push(
      <div key="maven" className="grid pb- phone--pl phone--pt">
        <div className="col-1-1">Maven:</div>
        <div className="grid__item col-1-1">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerMaven
            component={libraryModel}
            version={activeVersion}
          />
        </div>
      </div>
    );
    packageManagerElements.push(
      <div key="gradle" className="grid pb- phone--pl phone--pt">
        <div className="col-1-1">Gradle:</div>
        <div className="grid__item col-1-1">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerGradle
            component={libraryModel}
            version={activeVersion}
          />
        </div>
      </div>
    );
    packageManagerElements.push(
      <div key="sbt" className="grid pb- phone--pl phone--pt">
        <div className="col-1-1">sbt:</div>
        <div className="grid__item col-1-1">
          <ArtifactViewMainContentSignaturesComponentVersionPackageManagerSBT
            component={libraryModel}
            version={activeVersion}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="grid pb+">
      <div className="grid__item col-3-5">
        <div className="grid">
          <div className="grid__item col-1-1">{fileHashesElement}</div>
          <div className="grid__item col-1-1">{bytecodeHashElement}</div>
        </div>
      </div>
      <div className="grid__item col-2-5">{packageManagerElements}</div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
  };
}
export default connect(mapStateToProps)(LibraryViewVersionEvidence);
